<!-- HEADER -->
<header class="
  w-full flex flex-wrap px-4 py-8 justify-between
  bg-gradient-to-r from-blue-500 to-blue-800
">
  <div class="w-full lg:w-4/12 flex flex-wrap content-center justify-center lg:justify-start">
    <img src="/assets/logos/ncda-logo.png" class="w-14 h-14 rounded-full bg-white"/>
    <img src="/assets/logos/bagong-pilipinas-logo.png" class="w-14 h-14 rounded-full mx-4"/>
    <div class="w-14 h-14 rounded-sm bg-white">
      <img src="/assets/logos/DSWD-Logo-Icon.png" class="w-14 h-14"/>
    </div>
  </div>

  <div class="w-full lg:w-4/12 mt-6 lg:mt-0 text-center text-blue-100 uppercase text-2xl font-light">Department of Social Welfare and Development</div>

  <div class="w-full flex flex-wrap item-center justify-center mt-6 lg:mt-0 lg:justify-end relative lg:w-4/12">
    <img src="/assets/logos/govph-logo-sm.png" class="w-22 h-20 lg:absolute"/>
  </div>
</header>

<!-- MAIN -->
<div class="w-full flex flex-wrap flex-col-reverse lg:flex-row lg:min-h-[80vh]">
  <div class="w-full flex flex-wrap py-8 justify-center content-center bg-gray-200 lg:w-1/2 lg:min-h-[80vh]">
    <div class="w-full text-3xl font-bold text-gray-700 text-center mb-8">VERIFY YOUR ID</div>

    <div class="w-full md:w-1/2 px-6">
      <div class="w-full bg-white shadow-md rounded-lg p-4">
        <div class="w-full px-4 text-center mb-4">Scan with Your Camera</div>
        <div class="w-full px-4 text-gray-600 text-xs mb-2">
          <b class="text-gray-800">Prepare your ID.</b> Make sure the QR code is clearly visible and not covered by plastic glare. 
        </div>

        <div class="w-full px-4 text-gray-600 text-xs mb-2">
          <b class="text-gray-800">Allow camera access.</b> When prompted by your browser, choose the camera you want to use (rear camera recommended on mobile). 
        </div>

        <div class="w-full px-4 text-gray-600 text-xs mb-2">
          <b class="text-gray-800">Center the QR in the frame.</b> Hold the ID 10–15 cm away. Avoid shadows and screen reflections.
        </div>

        <div class="w-full px-4 text-gray-600 text-xs mb-2">
          <b class="text-gray-800">Wait for the beep/checkmark.</b> The reader auto-detects and decodes the QR code.
        </div>

        <div class="w-full px-4 text-gray-600 text-xs mb-2">
          <b class="text-gray-800">Review the details.</b> We’ll show the name and ID reference from your QR. 
        </div>
      </div>
    </div>

    <div class="w-full md:flex md:w-1/2 px-6 mt-6 md:mt-0">
      <div class="w-full bg-white shadow-md rounded-lg p-4">
        <div class="w-full px-4 text-center mb-4">Upload a Photo/Screenshot</div>

         <div class="w-full px-4 text-gray-600 text-xs mb-2">
          <b class="text-gray-800">Prepare your photo or screenshot.</b> Make sure the QR code is clearly visible among any other content in the image, with no glare or heavy shadows.
        </div>

        <div class="w-full px-4 text-gray-600 text-xs mb-2">
          <b class="text-gray-800">Select a file.</b> Click Upload QRCode to select a file. 
        </div>

        <div class="w-full px-4 text-gray-600 text-xs mb-2">
          <b class="text-gray-800">Supported formats</b> JPG, PNG, or WEBP (max 10 MB). Screenshots are okay
        </div>

        <div class="w-full px-4 text-gray-600 text-xs mb-2">
          <b class="text-gray-800">Automatic scan.</b> We’ll process the image and extract the QR data. 
        </div>

        <div class="w-full px-4 text-gray-600 text-xs mb-2">
          <b class="text-gray-800">Review the details</b> Check that your name and ID reference look correct.
        </div>
      </div>
    </div>

    <div class="w-10/12 text-center text-xs text-gray-400 mt-6 mx-auto border border-gray-300 p-4 lg:w-6/12">
      A message will appear if an error occurs during scanning.
    </div>
  </div>

  <div class="w-full flex flex-wrap justify-center py-8 items-center lg:w-1/2 bg-gray-100">
    <div class="flex flex-wrap w-11/12 bg-white shadow-md rounded-lg p-2 lg:8/12 lg:p-8">
      <div class="w-full flex flex-wrap content-center justify-center">
        <div class="w-full lg:w-8/12 relative aspect-square bg-slate-100 overflow-hidden rounded-md">
          <div id="reader" class="!absolute !inset-0"></div>
        </div>
      </div>

      <div class="w-full flex flex-wrap items-center justify-evenly mt-10">
        <button type="button" (click)="startCamera()"
          class="
            flex items-center border-2 rounded-md cursor-pointer
            border-blue-300 text-blue-600 py-2 px-4
            hover:bg-blue-600 hover:text-white font-light text-sm
          "
        >
          {{ scannerEnabled ? 'CLOSE SCANNER' : 'SCAN QRCODE' }}<i class="material-icons ms-1">qr_code_scanner</i>
        </button>
    
        <button type="button" *ngIf="!scannerEnabled" (click)="triggerUpload()"
          class="
            flex items-center border-2 rounded-md cursor-pointer relative
            border-blue-300 text-blue-600 py-2 px-4 mt-4 md:mt-0
            hover:bg-blue-600 hover:text-white font-light text-sm
          "
        >
          UPLOAD QRCODE <i class="material-icons ms-1">upload_file</i>
        </button>
        <input type="file" accept="image/*" #fileInput (change)="handleFile($event)" class="opacity-0">
      </div>

    </div>
  </div>  
</div>

<!-- FOOTER -->
<!-- <footer class="w-full flex flex-wrap p-8 bg-blue-500 text-white">
  <div class="w-full content-start flex flex-wrap md:w-1/2 lg:w-3/12">
    <div class="w-full mb-4 font-lg font-semibold lg:mb-8">GOVERNMENT LINKS</div>
    <div class="w-full font-light text-sm mb-2"
      *ngFor="let gl of links.government"
    >
      <a href="{{gl.link}}" class="hover:text-blue-200" target="__blank">{{ gl.name }}</a>
    </div>
  </div>

  <div class="w-full mt-8 content-start flex flex-wrap md:w-1/2 lg:w-3/12 md:mt-0">
    <div class="w-full mb-4 font-lg font-semibold lg:mb-8">OTHER RESOURCES</div>
    <div class="w-full font-light text-sm mb-2"
      *ngFor="let or of links.other"
    >
      <a href="{{or.link}}" class="hover:text-blue-200" target="__blank">{{ or.name }}</a>
    </div>
  </div>

  <div class="w-full mt-8 content-start flex flex-wrap md:w-1/2 lg:w-3/12 lg:mt-0">
    <div class="w-full mb-4 font-lg font-semibold lg:mb-8">CONTACT US</div>
    
    <div class="w-full text-sm font-semibold">Contact Numbers</div>

    <div class="w-full flex items-center text-sm font-light">
      <i class="material-icons !text-base me-2">call</i> (632) 8-931-81-08- to 07
    </div>

    <div class="w-full flex items-center text-sm font-light">
      <i class="material-icons !text-base me-2">smartphone</i> Globe: 0917-110-5686 / 0917-827-2543
    </div>

    <div class="w-full flex items-center text-sm font-light">
      <i class="material-icons !text-base me-2">smartphone</i> Smart: 0919-911-6200
    </div>

    <div class="w-full text-sm font-semibold mt-4">Email Address</div>
    <div class="w-full flex items-center justify-start text-sm font-light">
      <i class="material-icons !text-base me-2">email</i> inquiry@dswd.gov.ph
    </div>
  </div>

  <div class="w-full mt-8 flex content-start flex-wrap md:w-1/2 lg:w-3/12 lg:mt-0">
    <div class="w-full mb-4 font-lg font-semibold lg:mb-2">FOLLOW US</div>

    <div class="w-full flex flex-wrap items-center mb-6">
      <a href="https://www.facebook.com/dswdserves" class="mr-4" target="__blank">
        <img src="/assets/logos/facebook.svg" alt="" class="w-6 fill-white">
      </a>
      
      <a href="https://www.youtube.com/dswdserves" target="__blank" class="mr-4">
        <img src="/assets/logos/youtube.svg" alt="" class="w-6">
      </a>
      
      <a href="https://www.tiktok.com/@angelsinredvestsph/" target="__blank" class="mr-4">
        <img src="/assets/logos/tiktok.svg" alt="" class="w-6">
      </a>
      
      <a href="https://x.com/dswdserves" target="__blank" class="mr-4">
        <img src="/assets/logos/x.svg" alt="" class="w-6">
      </a>
      
      <a href="https://www.instagram.com/dswdphilippines/" target="__blank" class="mr-4">
        <img src="/assets/logos/instagram.svg" alt="" class="w-6">
      </a>
    </div>

    <div class="w-full flex">
      <a href="https://clientfeedback.dswd.gov.ph/" class="w-full md:w-8/12">
        <img src="/assets/logos/kliyentell-logo.png" alt="" class="w-full">
      </a>
    </div>
  </div>
</footer> -->



<!-- COMPONENTS -->
<!-- loading -->
<div class="w-full fixed inset-0 z-50 bg-[rgba(0,0,0,0.5)]" *ngIf="loading">
  <div class="
    w-10/12 lg:w-4/12  bg-white shadow-md rounded-lg p-4
    absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
  ">
    <div class="w-full flex items-center justify-center">
      <span class="inline-block w-10 h-10 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></span>
    </div>

    <div class="w-full text-center p-4">
      {{ loading_message }}
    </div>

    <div class="w-full text-center px-4 py-2 text-slate-700 font-semibold">
      {{ qrcodeValue?.subject?.firstName }} {{ qrcodeValue?.subject?.middleName }} {{ qrcodeValue?.subject?.lastName }}
    </div>

    <div class="text-center p-2 bg-blue-100 text-blue-800">
      {{ qrcodeValue?.subject?.UDI }}
    </div>
  </div>
</div>

<!-- alert -->
<div class="w-full fixed inset-0 z-50 bg-[rgba(0,0,0,0.5)]" *ngIf="alert">
  <button class="fixed bg-transparent inset-0" (click)="hideAlert()"></button>

  <div
    [ngClass]="{
      'bg-red-200 border-2 border-red-900 text-red-900': alert_type === 'error',
      'bg-green-200 border-2 border-green-900 text-green-900': alert_type === 'success'
    }"
    class="
      w-10/12 lg:w-4/12 rounded-lg p-4
      absolute top-1/12 left-1/2 -translate-x-1/2
    "
  >
    {{ alert_message }}

    <button (click)="hideAlert()"
      class="absolute text-2xl -right-2 -top-2 bg-white border-2 border-slate-800 text-gray-600 cursor-pointer w-6 h-6 rounded-full flex items-center justify-center"
    >&times;</button>
  </div>
</div>

<!-- profile success modal -->
 <div class="w-full fixed inset-0 z-50 bg-[rgba(0,0,0,0.2)] shadow-md" *ngIf="profileModal">
  <button class="fixed bg-transparent inset-0" (click)="hideSuccessScan()"></button>

  <div class="
    w-10/12 lg:w-3/12 rounded-xl bg-blue-800 border-4 border-white
    absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
    flex flex-wrap
  ">
    <div class="w-full flex flex-wrap relative py-16 lg:py-16 md:py-30 bg-blue-500 rounded-tl-lg rounded-tr-lg">
      <img class="w-5/12 lg:w-1/3 aspect-square mx-auto rounded-sm absolute left-1/2 -translate-x-1/2 top-10 border-2 border-white"
        src="{{ profile_modal_data.img }}"
      >
    </div>
    
    <div class="w-full flex flex-wrap text-white font-light mt-20 px-4">
      <div class="w-full text-xs lg:text-base flex justify-start uppercase">
        <span>{{ profile_modal_data.firstname }}</span>
        <span class="ml-2" *ngIf="profile_modal_data.middlename">
          {{ profile_modal_data.middlename }}
        </span>
        <span class="ml-2">{{ profile_modal_data.lastname }}</span>
        <span class="ml-2" *ngIf="profile_modal_data.suffix">
          {{ profile_modal_data.suffix }}
        </span>
      </div>

      <div class="w-full flex text-xs lg:text-base flex-wrap justify-between mt-1">
        <span class="text-blue-200">Date Issued</span>
        <span>{{ profile_modal_data.date_issued }}</span>
      </div>
    </div>

    <div class="w-11/12 lg:w-10/12 flex flex-wrap rounded-sm mx-auto px-4 py-2 mt-6">
      <div class="w-full text-xs text-center font-bold bg-amber-400 text-blue-800 rounded-tl-md rounded-tr-md py-2">ID NO</div>
      <div class="
        w-full lg:text-lg text-center text-white py-3 font-light
        border-2 border-amber-400 rounded-bl-md rounded-br-md
      ">{{ profile_modal_data.id }}</div>
    </div>

    <div class="w-full flex justify-center">
      <span class="w-auto mx-auto text-center font-bold text-lg mt-6 px-3 py-1 relative"
        [ngClass]="{
          'text-green-400': profile_modal_data.verified,
          'text-gray-400': !profile_modal_data.verified
        }"
      >
        {{ (profile_modal_data.verified) ? 'VERIFIED' : 'NOT VERIFIED' }}

        <i class="material-icons absolute -top-2 -right-2 !text-xl" *ngIf="profile_modal_data.verified">verified</i>
      </span>
    </div>

    <div class="w-full flex flex-col justify-center items-center mt-4" *ngIf="profile_modal_data.benefits?.length">
      <div class="text-xs text-blue-200 mb-2 uppercase tracking-wider">Benefits</div>
      <div class="flex flex-wrap gap-2">
        <span class="px-2 py-1 text-xs font-semibold bg-amber-400 text-blue-900 rounded-md"
          *ngFor="let code of profile_modal_data.benefits"
        >{{ code }}</span>
      </div>
    </div>

    <button class="w-10/12 lg:w-8/12 mt-16 mb-8 mx-auto font-semibold text-sm text-blue-800 bg-white px-4 py-3 rounded-md cursor-pointer"
      (click)="hideSuccessScan()"
    >CLOSE</button>
  </div>
</div>